<template>
  <div class="step-container scrollPosition">
    <div class="step-header">
      <h2 class="step-title">Zustand</h2>
      <p class="step-text">In welchem Zustand befindet sich die Wohnung?</p>
    </div>
    <div class="step-body">
      <div class="box-container">
        <ActionBox
          class="box-item small-icon-w-50"
          text="Neubau<br/>(Erstbezug)"
          @click="setZustand(90)"
          :iconDefault="require('@/assets/icons/Svgs/new_building.svg')"
          :iconHover="require('@/assets/icons/Svgs/new_building_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Neue Generalsanierung"
          @click="setZustand(85)"
          :iconDefault="require('@/assets/icons/Svgs/neue_generalsanierung.svg')"
          :iconHover="require('@/assets/icons/Svgs/neue_generalsanierung_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Teilsanierung / <br/>Modernisierung"
          @click="setZustand(60)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8386.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8386_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Normal<br/>(dem Alter entsprechend)"
          @click="setZustand(40)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8398.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8398_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Leicht<br/>sanierungsbedürftig"
          @click="setZustand(30)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8388.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8388_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Generalsanierung ist erforderlich"
          @click="setZustand(20)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8389.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8389_white.svg')"
        />
      </div>
    </div>
    <div class="step-footer">
      <div class="row">
        <div class="col-md-4 col-sm-4 text-start">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionBox from "@/components/shared/ActionBox.vue";
import { saveToStorage } from "@/utils.js";
export default {
  name: "wohnung-step-6",
  components: {
    ActionBox,
  },
  data() {
    return {
      fields: {
        indexWhgErhaltung: { value: 10 },
      },
    };
  },
  methods: {
    setZustand(index) {
      this.fields.indexWhgErhaltung.value = index;
      saveToStorage(this.fields);
      this.$router.push("/wohnung-step-7");
    },
    goBack() {
      this.$router.push("/wohnung-step-5");
    },
  },
  mounted() {
    this.$emit("setStep", "wohnung", 7);
  },
};
</script>
<style scoped>
.box-container {
  gap: 30px;
}
.box-item {
  flex-basis: 180px;
  height: 190px;
}
@media only screen and (max-width: 768px) {
  .box-container {
    gap: 20px;
  }
  .box-item {
    height: 100%;
  }
}
</style>
